import { forwardRef } from "react";
function SvgRawChevronRightIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        d="m10 27 11-11L10 5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawChevronRightIcon);
export default ForwardRef;
